import { ReactNode } from 'react';
import styled from '@emotion/styled';

export interface sectionWrapperProps {
  children: ReactNode | ReactNode[];
  padding?: string;
  bgColor?: string;
  height?: string | number;
}

export const Container = styled.div<sectionWrapperProps>`
display: flex;
flex-direction: column;
background-color: ${({ bgColor }) => bgColor};
  width: 100%;
  height: ${({ height }) =>
    typeof height === 'string' ? height : `${height}%`};
  padding: ${({ padding }) =>
    padding ?? '0px'};
  box-sizing: border-box;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
  };
  
`;
